import React from 'react';
import { Link } from 'react-router-dom';
import './Suggests.css';  // Import the newly created CSS file

const Suggests = () => {
  return (
    <div className="suggests-container">
            <div className="notice">
        <p>שימו לב, לכל חבילה ניתן להוסיף רשומות במחיר של שקל לרשומה</p>
        <p>בנוסף, ניתן להוסיף הגעה שלנו לאולם וליווי ביום האירוע בעלות של 1,200 ש"ח בלבד</p>
      </div>
      <h1>
        <div className="packages-container">
         {/* Premium Package */}
         <div className="package">
            <h2>חבילת פרימיום</h2>
            <span>שלוש הודעות ווצאפ ,</span>
            <span>הודעה עם מיקום ביום עצמו</span>
            <span>ושתי שיחות טלפון</span>
            <span>עבור כל מוזמן.</span>
            <span>מעקב קל ונוח אחר אישורי הגעה.</span>
            <span>סידור שולחנות ומקומות ישיבה.</span>
            <span>(עד 600 רשומות)</span>
            <span>~רק 750 ש"ח~</span>
            <li className="center-bottom-item">
            <Link to="/buy?packege=premium">לרכישה</Link>
            </li>
          </div>


          {/* Medium Package */}
          <div className="package">
            <h2>חבילת מדיום</h2>
            <span>שלוש הודעות ווצאפ לכל מוזמן</span>
            <span>מעקב קל ונוח אחר אישורי הגעה</span>
            <span>(עד 600 רשומות)</span>
            <span>סידור שולחנות ומקומות ישיבה</span>
            <span>~רק 400 ש"ח~</span>
            <li className="center-bottom-item">
            <Link to="/buy?packege=medium">לרכישה</Link>
            </li>
          </div>

            {/* Basic Package */}
            <div className="package">
            <h2>חבילת בסיס</h2>
            <span>שליחת הודעות עצמאית ומעקב אחר אישורי הגעה</span>
            <span>(עד 200 רשומות)</span>
            <span>סידור שולחנות ומקומות ישיבה</span>
            <span>~רק 150 ש"ח~</span>
            <li className="center-bottom-item">
            <Link to="/buy?packege=basic">לרכישה</Link>
            </li>
          </div>

        </div>
      </h1>
    </div>
  );
};

export default Suggests;
